export default __webpack_public_path__ + "static/media/2020.87dcb3f0.png";